import { CotecnaUser } from "@cotecna/session";

export class User implements CotecnaUser {
  email: string;
  roles: string[];
  id: string;
  name: string;
  password: string;
  rememberMe: boolean;
  firstName: string;
  lastName: string;
  token: string;
  accountId: string;
  secondaryAccountIds: string[];
  mainAddress: string;
  multipleAddresses: Address[];
  selectedAcc: string;
  loginSource: LoginSource;
  accountName: string;
  typeName: string;
  latitude: number;
  longitude: number;
  marker: any;
  type: LoginSource;
  remainingCapacityInHours: number;
  public constructor(attributes: User = null) {
    Object.assign(this, attributes);
  }
}

export enum LoginSource {
  internal,
  external,
}

export class Address {
  id: string;
  text: string;
  latitude: number;
  longitude: number;
}
